import Vue from 'vue';
import KEY_CODES from '@dui/helpers/key-codes';

const CLASSES = {
  active: 'active',
  modal: 'modal',
  overlay: 'overlay',
};

function getModalElFromInside(element) {
  if (!element) {
    return null;
  }

  if (element.classList.contains(CLASSES.modal)) {
    return element;
  }

  return getModalElFromInside(element.parentElement);
}

export class ModalHandler {
  static addEventListeners(modalEl) {
    const overlayEl = ModalHandler.getModalOverlay(modalEl);
    if (!overlayEl) {
      return;
    }

    overlayEl.addEventListener('click', ModalHandler.hideFromOverlay);

    window.addEventListener('keyup', ModalHandler.keyUpPerformed);
  }

  static getModal(selector) {
    if (!selector) {
      return null;
    }

    return document.querySelector(selector);
  }

  static getModalOverlay(modalEl) {
    return modalEl.querySelector(`.${ CLASSES.overlay }`);
  }

  static hideAllModals() {
    const allModalEls = document.querySelectorAll(`.${ CLASSES.modal }.${ CLASSES.active }`);
    [].forEach.call(allModalEls, (modalEl) => {
      const overlayEl = ModalHandler.getModalOverlay(modalEl);
      ModalHandler.removeEventListeners(overlayEl);
      ModalHandler.hideModal(modalEl);
    });
  }

  static hideModal(modalEl) {
    if (!modalEl.classList.contains(CLASSES.active)) {
      return;
    }

    modalEl.classList.remove(CLASSES.active);
  }

  static hideFromButton(event) {
    const buttonEl = event.target;
    const modalEl = getModalElFromInside(buttonEl);
    if (!modalEl) {
      return;
    }

    const overlayEl = ModalHandler.getModalOverlay(modalEl);
    ModalHandler.removeEventListeners(overlayEl);
    ModalHandler.hideModal(modalEl);
  }

  static hideFromOverlay(event) {
    const overlayEl = event.target;
    const modalEl = overlayEl.parentElement;

    ModalHandler.removeEventListeners(overlayEl);
    ModalHandler.hideModal(modalEl);
  }

  static keyUpPerformed(event) {
    if (event.keyCode !== KEY_CODES.ESCAPE) {
      return;
    }

    ModalHandler.hideAllModals();
  }

  static removeEventListeners(overlayEl) {
    overlayEl.removeEventListener('click', ModalHandler.hideFromOverlay);
    window.removeEventListener('keyup', ModalHandler.keyUpPerformed);
  }

  static show(selector) {
    const modalEl = ModalHandler.getModal(selector);

    if (!modalEl) {
      return;
    }

    if (modalEl.classList.contains(CLASSES.active)) {
      return;
    }

    modalEl.classList.add(CLASSES.active);

    ModalHandler.addEventListeners(modalEl);
  }
}

export default {
  install: function(Vue, options) {
    Vue.prototype.modalHandler = ModalHandler;
  },
};
